// extracted by css-extract-rspack-plugin
export default {"cls1":"SidebarSection-cls1_08-","cls2":"SidebarSection-cls2_y03 SidebarSection-cls1_08-"};